import React from 'react'
    
const Navbar = () => {

    return (
        <div>Navbar</div>
      )
    }
    
export default Navbar;